import { useApi } from '@gik/core/api';
import { ConfigInterface, responseInterface } from 'swr';
import { useWPApi } from '@gik/core/api';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';
import { Product } from '@gik/core/models/gik/Product';
import { apiCap } from '..';

const path = 'products';

export function useSimilarProducts(
  relationIds: number[],
  taxonomySlugs: string[] = ['situation'],
  config?: ConfigInterface
) {
  const searchParams = {
    relationIds: relationIds?.join(','),
    taxonomies: taxonomySlugs?.join(','),
  };

  return useApi<Product[]>(relationIds && taxonomySlugs ? path : null, config, {
    searchParams,
  });
}

function getParams(productIds: string[]) {
  return {
    include: productIds.join(','),
    per_page: apiCap,
  };
}

export function useProducts<Data = Product[], Error = WordpressError>(
  productIds?: string[],
  config?: ConfigInterface
): responseInterface<Data, Error> {
  return useWPApi<Data, Error>(productIds.length > 0 ? path : null, config, {
    searchParams: getParams(productIds),
  });
}
